export default "__VITE_ASSET__C532zP2U__"